import { useAppSelector } from './useAppSelector';

export default function useCanModifyUrlExceptions() {
  const user = useAppSelector((state) => state.user);
  return !!user.group?.modifyUrlExceptions;
}
